export default {
    axisDefaults: {
        type: Object,
        default: undefined
    },
    categoryAxis: {
        type: [Array, Object],
        default: undefined
    },
    chartArea: {
        type: Object,
        default: undefined
    },
    data: {
        type: Array,
        default: undefined
    },
    dataSource: {
        type: Object,
        default: undefined
    },
    autoBind: {
        type: Boolean,
        default: undefined
    },
    plotArea: {
        type: Object,
        default: undefined
    },
    pointWidth: {
        type: Number,
        default: undefined
    },
    renderAs: {
        type: String,
        default: undefined
    },
    series: {
        type: Array,
        default: undefined
    },
    seriesColors: {
        type: Array,
        default: undefined
    },
    seriesDefaults: {
        type: Object,
        default: undefined
    },
    theme: {
        type: String,
        default: undefined
    },
    tooltip: {
        type: Object,
        default: undefined
    },
    transitions: {
        type: Boolean,
        default: undefined
    },
    type: {
        type: String,
        default: undefined
    },
    valueAxis: {
        type: [Array, Object],
        default: undefined
    },

    // Events
    axisLabelClick: {
        type: Function,
        default: undefined
    }, 
    dataBound: {
        type: Function,
        default: undefined
    }, 
    dragStart: {
        type: Function,
        default: undefined
    }, 
    drag: {
        type: Function,
        default: undefined
    }, 
    dragEnd: {
        type: Function,
        default: undefined
    }, 
    plotAreaClick: {
        type: Function,
        default: undefined
    }, 
    seriesClick: {
        type: Function,
        default: undefined
    }, 
    seriesOver: {
        type: Function,
        default: undefined
    }, 
    seriesHover: {
        type: Function,
        default: undefined
    }, 
    zoomStart: {
        type: Function,
        default: undefined
    }, 
    zoom: {
        type: Function,
        default: undefined
    }, 
    zoomEnd: Function
}


// WEBPACK FOOTER //
// ./packages/kendo-charts-vue-wrapper/src/KendoSparkline/SparklineProps.js